import { Injectable } from '@angular/core';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { Language } from '@nimbus-library/features/localization/models/enums/language.enum';
import { PersistedLocalizationService } from '@nimbus-library/features/localization/services/persisted-localization.service';
import { CookieService } from '@nimbus-library/features/shared/services/cookies/cookies.service';
import { AdminPortalPreferencesApiClient } from '@nimbus-library/features/user-settings/services/admin-portal-preferences.api-client';
import { ADMIN_SUPPORTED_LANGUAGES } from './admin-supported-languages.const';

@Injectable()
export class AdminLocalizationService extends PersistedLocalizationService {
  protected readonly languageCookieKey: string = 'admin_language';
  protected readonly dateFormatCookieKey: string = 'admin_dateFormat';
  protected readonly ownerScopedCookies: boolean = true;

  public constructor(
    protected readonly cookieService: CookieService,
    protected readonly preferencesApiClient: AdminPortalPreferencesApiClient,
    protected readonly authenticationService: IAuthenticationService,
    protected readonly environmentConfigurationService: EnvironmentConfigurationService,
  ) {
    super(cookieService, preferencesApiClient, authenticationService, environmentConfigurationService);
  }

  public override getSupportedLanguages(): Language[] {
    return ADMIN_SUPPORTED_LANGUAGES;
  }
}
